import React from "react";
import { useViewSegment } from "./ViewSegment.hooks";

const ViewSegmentContext = React.createContext<ReturnType<
  typeof useViewSegment
> | null>(null);

export function useViewSegmentView() {
  const contextValue = React.useContext(ViewSegmentContext);
  if (!contextValue) {
    throw Error("Should be used inside the ViewSegmentProvider");
  }
  return contextValue;
}

export const ViewSegmentProvider = ViewSegmentContext.Provider;
